import Lotbar from './Lotbar.vue';

(function () {
  'use srict';

  new Vue({
    el: '[data-vue=lotbar]',
    components: { lotbar: Lotbar }
  });
})(window);
